import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import services from '@/service'
import Router from 'vue-router'

import './icons' // icon
import './permission' // permission control

import '@/styles/index.scss' // global css

import './plugins/element.js'

import './plugins/breadcrumb.js' // 面包屑

import './plugins/tableEmpty.js' // 空列表

import 'video.js/dist/video-js.css'

import uploader from 'vue-simple-uploader'

Vue.prototype.$services = services

Vue.use(uploader)

Vue.config.productionTip = false

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return routerPush.call(this, location).catch(error => error)
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
